import React from "react";
import { Link } from "react-router-dom";
import "./ProductDetail.css";

const CalviaceXT = () => {
  return (
    <div className="product-page">

      <div className="product-header">
        <div className="product-image">
          <img src="/images/calviace.jpg" alt="Calviace XT" />
        </div>

        <div className="product-content">
          <span className="category">Nutraceutical</span>

          <h1>Calviace-XT</h1>

          <p className="subtitle">
            Advanced Calcium, Vitamin D3 & Neuro Support Formula
          </p>

          <h3>Composition</h3>

          <ul>
            <li>Calcium Carbonate</li>
            <li>Vitamin D3</li>
            <li>Methylcobalamin</li>
            <li>L-Methylfolate Calcium</li>
            <li>Pyridoxal-5-Phosphate</li>
          </ul>

          <Link to="/contact" className="enquiry-btn">
            Enquiry Now
          </Link>
        </div>
      </div>

      <section className="details-section">

        <h2>Product Overview</h2>

        <p>
          Calviace-XT is a nutritional supplement formulated to support bone
          health and nerve function. It combines elemental calcium with Vitamin
          D3 and neurotropic vitamins for comprehensive support.
        </p>

      </section>

      <section className="details-section">

        <h2>Key Benefits</h2>

        <ul>
          <li>Supports healthy bones and teeth.</li>
          <li>Helps maintain calcium levels.</li>
          <li>Supports nerve health.</li>
          <li>Improves calcium absorption.</li>
          <li>Useful in calcium deficiency.</li>
        </ul>

      </section>

      <section className="details-section">

        <h2>Dosage</h2>

        <p>As directed by the physician.</p>

      </section>

      <section className="details-section">

        <h2>Storage</h2>

        <p>
          Store in a dry place below 25°C. Protect from moisture and direct
          sunlight.
        </p>

      </section>

      <section className="details-section">

        <h2>Pack Size</h2>

        <p>10 x 10 Tablets</p>

      </section>

      <section className="disclaimer">

        <strong>Disclaimer</strong>

        <p>
          To be used only under medical supervision.
        </p>

      </section>

    </div>
  );
};

export default CalviaceXT;